var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"queryBuilderContainer"}},[_c('query-builder',{attrs:{"header-title":"New DMS Query","is-template":false},on:{"save":_vm.handleSave}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }